module.exports = __webpack_public_path__ + "img/icon_barco.7ff20db3.svg";